import type { Sharp } from "sharp";

export const backgroundImageWidths = Object.freeze([1024, 1366, 1600, 1920]);
export const mobileBackgroundImageWidths = Object.freeze([320, 480, 768]);
export const backgroundImageFormats = Object.freeze({
  webp: (s: Sharp) => s.webp(),
  jpeg: (s: Sharp) => s.jpeg(),
});
